<template>
  <div class="kds-avatar-stack" aria-hidden="true">
    <KdsAvatar
      v-for="(seg, idx) in visibleSegments"
      :key="`${seg}-${idx}`"
      :segment="seg"
      :size="size as KdsAvatarSize"
      class="kds-avatar-stack__avatar"
    />
    <span
      v-if="overflowCount > 0"
      class="kds-avatar-stack__overflow font-mono"
      :style="{ width: `${size}px`, height: `${size}px`, fontSize: 'var(--fs-meta)' }"
    >+{{ overflowCount }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import KdsAvatar from './KdsAvatar.vue';
import type { KdsAvatarSize, PersonaSegment } from '@/kds/types';

interface Props {
  segments: PersonaSegment[];
  max?: number;
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  max: 5,
  size: 20
});

const visibleSegments = computed<PersonaSegment[]>(() =>
  props.segments.slice(0, props.max)
);

const overflowCount = computed<number>(() =>
  Math.max(0, props.segments.length - props.max)
);
</script>

<style scoped lang="scss">
.kds-avatar-stack {
  display: flex;
  align-items: center;

  &__avatar {
    border: 2px solid var(--paper);
    border-radius: var(--r-pill);

    & + & {
      margin-left: -6px;
    }
  }

  &__overflow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--r-pill);
    border: 2px solid var(--paper);
    background: var(--paper-2);
    color: var(--stone);
    font-family: var(--font-mono);
    font-size: var(--fs-meta);
    margin-left: -6px;
    flex-shrink: 0;
  }
}
</style>
